import {
  PORTFOLIO_SCENARIO_COMPARE_REQUEST,
  PORTFOLIO_SCENARIO_COMPARE_SUCCESS,
  PORTFOLIO_SCENARIO_COMPARE_ERROR,
  PORTFOLIO_SCENARIO_COMPARE_RESET,
  PORTFOLIO_HEALTH_KPIS_REQUEST,
  PORTFOLIO_HEALTH_KPIS_SUCCESS,
  PORTFOLIO_HEALTH_KPIS_ERROR,
} from "./portfolioScenarioCompareActionTypes";

const initialState = {
  data: null,
  loading: false,
  error: null,
  health: {
    data: null,
    loading: false,
    error: null,
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function portfolioScenarioCompareReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case PORTFOLIO_SCENARIO_COMPARE_REQUEST:
      return { ...state, loading: true, error: null };
    case PORTFOLIO_SCENARIO_COMPARE_SUCCESS:
      return { ...state, data: payload, loading: false, error: null };
    case PORTFOLIO_SCENARIO_COMPARE_ERROR:
      return { ...state, loading: false, error: payload };
    case PORTFOLIO_SCENARIO_COMPARE_RESET:
      return { ...initialState, health: state.health };
    case PORTFOLIO_HEALTH_KPIS_REQUEST:
      return { ...state, health: { ...state.health, loading: true, error: null } };
    case PORTFOLIO_HEALTH_KPIS_SUCCESS:
      return { ...state, health: { data: payload, loading: false, error: null } };
    case PORTFOLIO_HEALTH_KPIS_ERROR:
      return { ...state, health: { ...state.health, loading: false, error: payload } };
    default:
      return state;
  }
}
